import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/app/app-routes';
import { RequestConsent, ResponseConsent } from 'src/app/interfaces/consent.interface';
import {
	RequestValidateCustomerData,
	ResponseValidateCustomerData,
} from 'src/app/interfaces/customer-data.interface';
import {
	RequestGenerateSendOtp,
	ResponseGenerateSendOtp,
} from 'src/app/interfaces/generate-send-otp.interface';
import { ResponseInitialParameters } from 'src/app/interfaces/initial-parameters.interface';
import {
	RequestOtpValidation,
	ResponseOtpValidation,
} from 'src/app/interfaces/otp-validation.interface';
import { RequestTaxFolder, ResponseTaxFolder } from 'src/app/interfaces/tax-folder.interface';
import { SKIP_LOADER } from 'src/app/utils/constants';
import { environment } from 'src/environments';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	private baseUrl = environment.endPoints.simuladorPublicoPymeExp;

	constructor(private readonly http: HttpClient) {}

	initialParameters(product: string): Observable<ResponseInitialParameters> {
		return this.http.get<ResponseInitialParameters>(
			`${this.baseUrl}${ApiEndpoints.INITIAL_PARAMETERS}/${product}/parametros`
		);
	}

	validateCustomerData(
		request: RequestValidateCustomerData
	): Observable<ResponseValidateCustomerData> {
		return this.http.post<ResponseValidateCustomerData>(
			`${this.baseUrl}${ApiEndpoints.VALIDATE}`,
			request
		);
	}

	consent(request: RequestConsent): Observable<ResponseConsent> {
		return this.http.post<ResponseConsent>(`${this.baseUrl}${ApiEndpoints.CONSENT}`, request);
	}

	taxFolder(request: RequestTaxFolder): Observable<ResponseTaxFolder> {
		return this.http.post<ResponseTaxFolder>(
			`${this.baseUrl}${ApiEndpoints.REQUEST_TAX_FOLDER}`,
			request
		);
	}

	generateAndSendOtp(
		request: RequestGenerateSendOtp,
		skipLoader: boolean
	): Observable<ResponseGenerateSendOtp> {
		return this.http.post<ResponseGenerateSendOtp>(
			`${this.baseUrl}${ApiEndpoints.GENERATE_SEND_OTP}`,
			request,
			{ context: new HttpContext().set(SKIP_LOADER, skipLoader) }
		);
	}

	validateOtp(request: RequestOtpValidation): Observable<ResponseOtpValidation> {
		return this.http.post<ResponseOtpValidation>(
			`${this.baseUrl}${ApiEndpoints.OTP_VALIDATION}`,
			request
		);
	}
}
